<template>
  <div>
    <v-row>
      <v-col cols="7" sm="8">
        <TodoGoalDropDownDisplay
          :todoGoalId="todoGoalId"
          :isRequired="todoGoalIsRequired"
          :todoGoalList="todoGroupList"
          :readonly="readonly"
          @todoGoalIdChange="handleTodoGoalIdChange"
        ></TodoGoalDropDownDisplay>
      </v-col>
      <v-col cols="5" sm="4">
        <v-row>
          <v-col cols="6" v-if="showCreateTodoGoal && !readonly">
            <v-btn block outlined color="primary" @click="showAddGoalModalHandler">
              <v-icon>add</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" v-if="showEditButton && !readonly">
            <v-btn block outlined color="primary" @click="showEditGoalModalHandler">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <TodoGoalAddModal
      ref="todoGoalAddModal"
      @todoGoalCreated="todoGoalUpdatedHandler"
    ></TodoGoalAddModal>
    <TodoGoalEditModal
      ref="todoGoalEditModal"
      :todoGoalId="todoGoalId"
      @todoGoalUpdated="todoGoalUpdatedHandler"
    ></TodoGoalEditModal>
  </div>
</template>
<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import TodoGoalDropDownDisplay from './TodoGoalDropDownDisplay'
import TodoGoalAddModal from './TodoGoalAddModal'
import { ButtonCustomIcon } from '@/components/buttons'
import { DynamicModal } from '@/components/dialogs'
import TodoGoalEditModal from '@/components/todoGoals/TodoGoalEditModal'
import { userHasRoles, getCurrentUser } from '@/lib/authentication'

export default {
  components: {
    TodoGoalEditModal,
    TodoGoalDropDownDisplay,
    ButtonCustomIcon,
    DynamicModal,
    TodoGoalAddModal
  },
  props: [
    'todoGoalId',
    'todoGoalIsRequired',
    'showCreateTodoGoal',
    'readonly'
  ],
  computed: {
    ...mapFields('todoGroups', [
      'todoGroupList'
    ]),
    showEditButton () {
      return this.todoGoalId > 0
    }
  },
  methods: {
    ...mapActions('todoGroups', [
      'getTodoGroups'
    ]),
    ...mapActions('todoGroup', [
      'clearTodoGroup'
    ]),
    loadTodoGroups () {
      this.getTodoGroups()
    },
    handleTodoGoalIdChange (value) {
      this.$nextTick(() => {
        this.$emit('todoGoalIdChange', value)
      })
    },
    handleTodoGoalTargetDateChange (value) {
      this.$nextTick(() => {
        this.$emit('todoGoalTargetDateChange', value)
      })
    },
    showAddGoalModalHandler () {
      this.$refs.todoGoalAddModal.showModal()
    },
    todoGoalUpdatedHandler (todoGoalId, targetDate) {
      this.loadTodoGroups()
      if (todoGoalId) {
        this.handleTodoGoalIdChange(todoGoalId)
      }
      if (targetDate) {
        this.handleTodoGoalTargetDateChange(targetDate)
      }
    },
    showEditGoalModalHandler () {
      this.$refs.todoGoalEditModal.showModal()
    },
    getCurrentUser,
    userHasRoles
  },
  created () {
    this.loadTodoGroups()
  }
}
</script>
